<div
  *ngIf="(report?.dataDefinitionId | toDataDefinition | async)?.description"
  class="report-kpi"
  [class.--is-danger]="report?.isBottleneck"
  [class.--has-action-button]="!!actionButton"
>
  <div class="report-kpi__left">
    <div class="report-kpi__left__top" [innerHTML]="(report?.dataDefinitionId | toDataDefinition | async)?.description"></div>
    <div class="report-kpi__left__bottom --is-{{ report?.status | lowercase }}">
      <ion-icon *ngIf="report?.status === 'success'" name="arrow-up"></ion-icon>
      <ion-icon *ngIf="report?.status === 'warning'" name="arrow-down"></ion-icon>
      <ion-text [innerHTML]="report?.value | parseReportValue: (report?.dataDefinitionId | toDataDefinition | async)"></ion-text>
    </div>
  </div>

  <div class="report-kpi__right">
    <div *ngIf="report | parseReportEmoji; let source" class="report-kpi__right__square">
      <ion-img [src]="source"></ion-img>
    </div>
  </div>
</div>

<app-report-action-button
  *ngIf="report?.isBottleneck && actionButton"
  class="report-kpi__action-button"
  [actionButton]="actionButton"
></app-report-action-button>
